$(document).ready(function () {

  var $navbar = $('#mainNav');
  var $navLinks = $('.nav-link');
  var $toggleBtn = $('.navbar-toggle');
  var $navMenu = $('.nav-links');

  $navLinks.first().addClass('active');

  $(window).on('scroll', function () {
    $navbar.toggleClass('scrolled', $(window).scrollTop() > 50);
  });

  $toggleBtn.on('click', function () {
    $navMenu.toggleClass('open');
  });

  $navLinks.on('click', function () {
    var $this = $(this);
    $navLinks.removeClass('active');
    $this.addClass('active');
    $navMenu.removeClass('open');
  });

  var observerOptions = { threshold: 0.3, rootMargin: '-80px 0px 0px 0px' };
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var id = entry.target.id;
        $navLinks.each(function () {
          $(this).toggleClass('active', $(this).attr('href') === '#' + id);
        });
      }
    });
  }, observerOptions);

  $('section[id]').each(function () {
    observer.observe(this);
  });

  $('.faq-question').on('click', function () {
    var $item = $(this).closest('.faq-item');
    var isActive = $item.hasClass('active');

    $('.faq-item.active').removeClass('active');

    if (!isActive) {
      $item.addClass('active');
    }
  });

  var fadeObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        $(entry.target).addClass('visible');
        fadeObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  $('.fade-in').each(function () {
    fadeObserver.observe(this);
  });

  $('.hiw-nav-step').on('click', function () {
    var $this = $(this);
    var target = $this.data('step');

    $('.hiw-nav-step').removeClass('active');
    $this.addClass('active');

    $('.hiw-panel').removeClass('active')
      .filter('[data-panel="' + target + '"]').addClass('active');
  });

  (function () {
    var testimonials = [
      {
        name: 'عبدالله السلماني',
        title: 'مؤسس',
        company: 'Space Point Academy',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
        text: 'كان عندنا تحدي في إنشاء منصة للأكاديمية وما كنا متخيلين إن كاديمي بتخلينا نسوي منصة في خمس دقايق بس. شكراً كاديمي — فعلاً غيرت طريقة تدريسنا للأفضل.',
        stars: 5
      },
      {
        name: 'أحمد كناوي',
        title: 'مدرب تقني',
        company: 'Salahly Academy',
        avatar: 'https://randomuser.me/api/portraits/men/45.jpg',
        text: 'قدرنا ننفذ خطتنا في التعليم الأونلاين بسهولة ونعمل منصة متكاملة للفنيين بشكل احترافي. أنصح الجميع بتجربة كاديمي.',
        stars: 5
      },
      {
        name: 'عبدالله عبادة',
        title: 'مهندس برمجيات',
        company: 'SW Testing Academy',
        avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
        text: 'شكراً كاديمي خدمة ممتازة. عملنا منصة متكاملة لمجتمع مهندسي الـ Software Quality في ساعة واحدة وبجودة عالية.',
        stars: 5
      },
      {
        name: 'نورة الحربي',
        title: 'مدربة ومستشارة تعليمية',
        company: 'مستقلة',
        avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
        text: 'منصة رائعة وسهلة الاستخدام. قدرت أطلق دوراتي في أقل من يوم وبدأت أحقق أرباح. أنصح بها كل من يريد بدء مشواره التعليمي.',
        stars: 5
      },
      {
        name: 'سارة الدوسري',
        title: 'رائدة أعمال',
        company: 'EduTech Solutions',
        avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
        text: 'كاديمي غيرت قواعد اللعبة في التعليم الإلكتروني. استطعنا مضاعفة عدد طلابنا في ٣ أشهر فقط بفضل المنصة المتكاملة والسهلة.',
        stars: 5
      }
    ];

    var current = 0;
    var isAnimating = false;

    var $avatar = $('#tsCardAvatar');
    var $nameEl = $('#tsCardName');
    var $titleEl = $('#tsCardTitle');
    var $companyEl = $('#tsCardCompany');
    var $bubbleText = $('#tsBubbleText');
    var $bubbleStars = $('#tsBubbleStars');
    var $bubbleAuthorName = $('#tsBubbleAuthorName');
    var $bubbleAuthorMeta = $('#tsBubbleAuthorMeta');
    var $thumbsContainer = $('#tsThumbs');

    var $animEls = $(
      '#tsCardAvatar, #tsCardName, #tsCardTitle, #tsCardCompany, ' +
      '#tsBubbleText, #tsBubbleStars, #tsBubbleAuthorName, #tsBubbleAuthorMeta'
    );

    function getStars(n) {
      return '★★★★★'.slice(5 - n);
    }

    function renderThumbs() {
      $thumbsContainer.empty();
      $.each(testimonials, function (i, t) {
        var $btn = $('<button class="ts-thumb">').toggleClass('active', i === current);
        var $img = $('<img class="ts-thumb-avatar">').attr({ src: t.avatar, alt: '' });
        $btn.append($img).on('click', function () { goTo(i); });
        $thumbsContainer.append($btn);
      });
    }

    function setContent(t) {
      $avatar.attr('src', t.avatar);
      $nameEl.text(t.name);
      $titleEl.text(t.title);
      $companyEl.text(t.company);
      $bubbleText.text(t.text);
      $bubbleStars.text(getStars(t.stars));
      $bubbleAuthorName.text(t.name);
      $bubbleAuthorMeta.text(t.title + ' ' + t.company);
    }

    function updateInfo(index, animate) {
      var t = testimonials[index];

      if (animate) {
        $animEls.addClass('ts-exit');

        setTimeout(function () {
          setContent(t);
          $animEls.removeClass('ts-exit').addClass('ts-enter');

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              $animEls.removeClass('ts-enter');
            });
          });
        }, 350);
      } else {
        setContent(t);
      }
    }

    function updateThumbs(index) {
      $thumbsContainer.find('.ts-thumb').each(function (i) {
        $(this).toggleClass('active', i === index);
      });
    }

    function goTo(index) {
      if (isAnimating || index === current) return;
      var total = testimonials.length;
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      isAnimating = true;
      current = index;

      updateInfo(current, true);
      updateThumbs(current);

      setTimeout(function () { isAnimating = false; }, 700);
    }

    function prev() { goTo(current - 1); }
    function next() { goTo(current + 1); }

    var touchStartX = 0;
    var $composition = $('.ts-composition');

    $composition.on('touchstart', function (e) {
      touchStartX = e.originalEvent.changedTouches[0].screenX;
    }, { passive: true });

    $composition.on('touchend', function (e) {
      var touchEndX = e.originalEvent.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? next() : prev();
      }
    }, { passive: true });

    if ($avatar.length && $nameEl.length && $thumbsContainer.length) {
      renderThumbs();
      updateInfo(0, false);

      $('.ts-prev').on('click', prev);
      $('.ts-next').on('click', next);
    }
  })();

  $('.lf-pw-toggle').on('click', function () {
    var $input = $(this).siblings('input');
    if (!$input.length) return;
    var isPassword = $input.attr('type') === 'password';
    $input.attr('type', isPassword ? 'text' : 'password');
    $(this).find('i').attr('class', isPassword ? 'ri-eye-off-line' : 'ri-eye-line');
  });

  if ($('.integrations-marquee').length) {
    new Swiper('.integrations-marquee', {
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,
      speed: 6000,
      allowTouchMove: false,
      autoplay: { delay: 1, disableOnInteraction: false }
    });
  }

  window.refreshRecaptcha = function (action) {
    if (typeof grecaptcha !== 'undefined' && grecaptcha.execute) {
      var recaptchaScript = $('script[src*="google.com/recaptcha/api.js"]').attr('src');
      if (recaptchaScript) {
        var sitekey = recaptchaScript.match(/render=([^&]+)/);
        if (sitekey && sitekey[1]) {
          grecaptcha.execute(sitekey[1], { action: action }).then(function (token) {
            $('input[name="g-recaptcha-response"]').val(token);
          });
        }
      }
    }
  };

  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-left",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "10000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
  };

  window.toast = function (type, message) {
    var titles = { success: "عملية ناجحة", error: "خطأ", warning: "تحذير", info: "معلومة" };
    if (toastr[type]) {
      toastr[type](message, titles[type] || "");
    }
  };

  window.displayResponseValidationErrors = function (jqXHR, textStatus, errorThrown) {
    if (jqXHR.responseJSON && jqXHR.responseJSON.errors) {
      $.each(jqXHR.responseJSON.errors, function (key, value) {
        $.each(value, function (index, message) {
          toast('error', message);
        });
      });
    } else {
      toast('error', errorThrown);
    }
  };

  window.initRedirectCountdown = function (delay, redirectUrl, countdownElementId) {
    countdownElementId = countdownElementId || 'countdown';
    var $countdownEl = $('#' + countdownElementId);
    var remaining = delay;

    var tick = function () {
      remaining = Math.max(0, remaining - 1);
      if ($countdownEl.length) {
        $countdownEl.text(String(remaining));
      }
      if (remaining <= 0) {
        window.location.replace(redirectUrl);
      }
    };

    if ($countdownEl.length) {
      $countdownEl.text(String(remaining));
    }

    setTimeout(tick, 1000);
    var interval = setInterval(function () {
      tick();
      if (remaining <= 0) {
        clearInterval(interval);
      }
    }, 1000);
  };

});
